import { DISPLAY_DATE, MM_SPACE_YYYY, YYYY } from "constants/date";
import { TIME_FORMAT } from "constants/date";
import {
  PERIOD,
  PERIOD_DATE_FORMAT,
  PeriodType,
} from "constants/revenueMetrics";
import dayjs from "dayjs";

export const formatDate = (date?: any) => {
  return date ? dayjs(date).format(DISPLAY_DATE) : dayjs().format(DISPLAY_DATE);
};

export const formatTime = (date?: any) => {
  return date ? dayjs(date).format(TIME_FORMAT) : dayjs().format(TIME_FORMAT);
};

export const formatTimeToMonthYear = (date?: any) => {
  return date
    ? dayjs(date).format(MM_SPACE_YYYY)
    : dayjs().format(MM_SPACE_YYYY);
};

export const formatDateToYear = (date?: any) => {
  return date ? dayjs(date).format(YYYY) : dayjs().format(YYYY);
};

export const formatDateByViewType = (
  date: string | Date,
  viewType: PeriodType
) => {
  switch (viewType) {
    case PERIOD.MONTHLY:
      return dayjs(date).format(PERIOD_DATE_FORMAT[viewType]);
    case PERIOD.YEARLY:
      return dayjs(date).format(PERIOD_DATE_FORMAT[viewType]);
    case PERIOD.QUARTERLY:
      return `Q${dayjs(date).format(PERIOD_DATE_FORMAT[viewType])}`;
    default:
      return dayjs(date).format(DISPLAY_DATE);
  }
};
